import { useState, type FormEvent } from 'react';
import {
  UMButton, UMFormGroup, UMFormStyles, UMInput, UMR, UMRadioGroup, UMSelect, UMSidePanel,
} from '../_components';
import type { ConsumptionType, SelectionDraft } from './types';
import { CONSUMPTION_TYPES, HEAT_NETWORK_OPTIONS, SELECTION_NAME_MAX, randomSelectionColor } from './selectionForm';
import { SelectionColorPicker } from './SelectionColorPicker';

// HomeSidebarSelectionForm.vue (production) : Informations / * Champs requis, nom (30 car.),
// couleur, réseau concerné (option vide par défaut), type de consommation (Chaud par défaut).
const NETWORK_OPTIONS = [{ value: '', label: '' }, ...HEAT_NETWORK_OPTIONS];
const CSS =
  '.sel-form-network select{border-radius:0!important}' +
  '.sel-form-consumption [role=radiogroup]{flex-direction:column;gap:8px!important}';

export function SelectionFormPanel({ onClose, onCancel, onSubmit }: {
  onClose: () => void;
  onCancel: () => void;
  onSubmit: (draft: SelectionDraft) => void;
}) {
  const [name, setName] = useState('');
  const [color, setColor] = useState(randomSelectionColor);
  const [networkId, setNetworkId] = useState('');
  const [consumption, setConsumption] = useState<ConsumptionType>('Chaud');
  const valid = name.trim().length > 0;
  const submit = (event?: FormEvent) => {
    event?.preventDefault();
    if (valid) onSubmit({ name: name.trim(), color, networkId, consumption });
  };
  return (
    <UMSidePanel title="Paramètres de la sélection" onClose={onClose} footer={<>
      <UMButton variant="secondary" onClick={onCancel}>Annuler</UMButton>
      <UMButton disabled={!valid} onClick={() => submit()}>Valider</UMButton>
    </>}>
      <UMFormStyles />
      <style>{CSS}</style>
      <form aria-label="Paramètres de la sélection" onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 16, lineHeight: '24px', fontWeight: 700, color: UMR.textStrong }}>Informations</div>
          <div style={{ fontSize: 12, lineHeight: UMR.lhXs, color: UMR.blue }}>* Champs requis</div>
        </div>
        <UMFormGroup label="Nom de la sélection *">
          <UMInput ariaLabel="Nom de la sélection" value={name}
            onChange={(v) => setName(v.slice(0, SELECTION_NAME_MAX))} />
          <div style={{ marginTop: 4, fontSize: 14, lineHeight: '21px', color: UMR.textSecondary }}>
            Limité à {SELECTION_NAME_MAX} caractères
          </div>
        </UMFormGroup>
        <UMFormGroup label="Couleur *">
          <SelectionColorPicker value={color} onChange={setColor} />
        </UMFormGroup>
        <div className="sel-form-network">
          <UMFormGroup label="Réseau concerné (optionnel)">
            <UMSelect ariaLabel="Réseau concerné (optionnel)" value={networkId} options={NETWORK_OPTIONS} onChange={setNetworkId} />
          </UMFormGroup>
        </div>
        <div className="sel-form-consumption">
          <UMFormGroup label="Type de consommation *">
            <UMRadioGroup name="selection-consumption" options={CONSUMPTION_TYPES} value={consumption}
              onChange={(v) => setConsumption(v as ConsumptionType)} />
          </UMFormGroup>
        </div>
      </form>
    </UMSidePanel>
  );
}
